/*
 * @Author: your name
 * @Date: 2021-12-29 16:44:16
 * @LastEditTime: 2024-11-11 10:21:36
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD置
 * @FilePath: /isp_International/src/index.tsx
 */
import React from 'react';
import ReactDOM from 'react-dom';
import './assets/style/global.scss';

import './assets/iconfont/RelayIcon.css';
import { bootstrapI18n } from './i18n';
import { setVnStyle } from '@/util/init.js';
import { setupMobileViewport } from '@/util/setupMobileViewport';
import { setupChunkLoadRecovery } from '@/util/chunkLoadRecovery';
import '@/util/langs';
import { openPage } from '@/util/userProfile';
import { isXcmgLoginPath, startXcmgLogin } from '@/util/xcmgLogin';
import AppRoot from './bootstrap/AppRoot';

window._openPage = openPage;

window.log = () => {
  return '';
};
setVnStyle();
setupMobileViewport();
setupChunkLoadRecovery();

const renderApp = () => {
  ReactDOM.render(<AppRoot />, document.getElementById('root'));
};

const startApp = async () => {
  try {
    // 首屏页面大量使用同步 TLT：有本地语言包缓存时用缓存同步挂载并后台刷新，
    // 仅首次访问无缓存时才等远程词条，避免首屏未翻译闪烁的同时去掉重复访问的串行 RTT。
    await bootstrapI18n();
  } catch (error) {
    console.error('i18n 初始化失败:', error);
  } finally {
    renderApp();
  }
};

// 避免免登录请求被拦截
if (isXcmgLoginPath()) {
  void startXcmgLogin();
} else {
  void startApp();
}
